import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import noImage from "../../img/nophoto.png";
import { generateStyle, l, setOverLay } from "../functions";
import Icon from "../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    storeLogo: state.rootReducer.storeLogo || null,
    settings: state.rootReducer.appearanceSettings || {},
  };
};

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProp, nextState) {
    const currentPayload = this.props?.payload;
    const nextPayload = nextProp?.payload;

    // console.log(JSON.stringify(currentPayload) === JSON.stringify(nextPayload));
    if (
      !isEqual(currentPayload, nextPayload) ||
      !isEqual(nextProp.settings, this.props.settings)
    ) {
      return true;
    }
    // console.log("re-render");
    return false;
  }

  _initImage = (preview, blockPreview = false) => {
    let { payload } = this.props;

    if (blockPreview || payload === null) payload = this.props.options.payload;

    let imageUrl =
      payload?.datas["imageUrl_" + this.props.currentLang] ||
      payload?.datas.imageUrl ||
      "";

    let { storeLogo } = payload.datas || {};

    // const displayMode = "ratio";
    const {
      sizeMode,
      imageWidth,
      textOverlay,
      isTextOverlay,
      textOverlayColor,
      altAttribute,
    } = payload.datas || {};

    if (payload.datas && payload.datas["imageUrl_" + this.props.currentLang])
      imageUrl = payload.datas["imageUrl_" + this.props.currentLang];
    if (storeLogo) imageUrl = this.props.storeLogo;

    let cssSettings = generateStyle(payload, "container");
    let cssAlignment = generateStyle(payload, "alignment");
    let cssText = generateStyle(payload, "text", "H3");
    if (textOverlayColor) {
      cssText = {
        ...cssText,
        color: textOverlayColor,
      };
    }

    let customCSS = {};

    let backgroundSize = "100% 100%";
    if (sizeMode === "custom") {
      customCSS = {
        height: "auto",
        width: imageWidth ? parseInt(imageWidth) : 250,
        backgroundSize: backgroundSize,
      };
    }

    const imageBorderStyle = {
      borderColor: cssSettings?.borderColor || "#000",
      borderRadius: cssSettings?.borderRadius,
      borderStyle: cssSettings?.borderStyle,
      borderWidth: cssSettings?.borderWidth,
      paddingBottom: cssSettings?.paddingBottom,
      paddingLeft: cssSettings?.paddingLeft,
      paddingRight: cssSettings?.paddingRight,
      paddingTop: cssSettings?.paddingTop,
    };
    cssSettings = {
      ...cssSettings,
      borderColor: null,
      borderRadius: null,
      borderStyle: null,
      borderWidth: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null,
      paddingTop: null,
    };

    return (
      <Container
        fluid={payload.fullContainer}
        style={{ ...cssSettings, overflow: "hidden" }}
      >
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol category-image" style={cssAlignment}>
            <>
              {!preview && <div className="overlay"></div>}
              {isTextOverlay && imageUrl && (
                <>
                  <div className="overlay-text">
                    {" "}
                    <img
                      src={imageUrl}
                      alt={altAttribute || ""}
                      style={{ ...customCSS, ...imageBorderStyle }}
                    />
                    <h3 style={cssText}>{textOverlay}</h3>
                  </div>
                </>
              )}
              {!isTextOverlay && imageUrl && (
                <img
                  src={imageUrl}
                  alt={altAttribute || ""}
                  style={{ ...customCSS, ...imageBorderStyle }}
                />
              )}
              {!imageUrl && (
                <img
                  style={{ height: 200, width: 200 }}
                  src={noImage}
                  alt={altAttribute || ""}
                />
              )}
            </>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          {(options.showPreview && this._initImage(false, true)) || (
            <span className="dragger">
              {(Array.isArray(rest.icon) && (
                <FontAwesomeIcon icon={rest.icon} />
              )) || <Icon icon={rest.icon} />}
              <span>{l(rest.name)}</span>
            </span>
          )}
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initImage(true, false)}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initImage()}
      </Draggable>
    );
  }
}

Image.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Image);
